parasails.registerPage('member-login', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    overallEventID: '',
    qrslug: '',
    fixedStampID: '',
    syncing: false,
    showFooter: true,
    useDarkLogos: true,
    // Form data
    formData: {
      rememberMe: true,
      accountRole: 'member'
    },
    // For tracking client-side validation errors in our form.
    // > Has property set to `true` for each invalid property in `formData`.
    formErrors: { /* … */ },
    // A set of validation rules for our form.
    // > The form will not be submitted if these are invalid.
    formRules: {
      emailAddress: { required: true, isEmail: true },
      password: { required: true },
    },
    // Server error state for the form
    cloudError: '',
    showPassword: false,
    loginMessage: '',
    eventLogo: 'images/caramel-logo.png',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.qrslug = urlParams.get('qrslug') || '';
    this.fixedStampID = urlParams.get('fixedStampID') || '';
    this.formData.eventID = this.overallEventID;
    this.setLogo();
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    buildAuthQuery: function() {
      var queryParts = [];
      if (this.overallEventID) {
        queryParts.push('eventID=' + encodeURIComponent(this.overallEventID));
      }
      if (this.qrslug) {
        queryParts.push('qrslug=' + encodeURIComponent(this.qrslug));
      }
      if (this.fixedStampID) {
        queryParts.push('fixedStampID=' + encodeURIComponent(this.fixedStampID));
      }
      return queryParts.join('&');
    },
    setLogo() {
      if(this.eventData) {
        if(this.eventData.logoImage) {
          this.eventLogo = this.eventData.logoImage;
        }
        if(this.eventData.subLogoImage) {
          this.subLogo = this.eventData.subLogoImage;
        }
      }
    },
    submittedForm: async function() {
      // Redirect to the logged-in dashboard on success.
      // > (Note that we re-enable the syncing state here.  This is on purpose--
      // > to make sure the spinner stays there until the page navigation finishes.)
      this.syncing = true;
      if (this.qrslug) {
        window.location = '/rally/entry/' + encodeURIComponent(this.qrslug);
        return;
      }
      if (this.fixedStampID) {
        window.location = '/rally/fixed/' + encodeURIComponent(this.overallEventID) + '/' + encodeURIComponent(this.fixedStampID);
        return;
      }
      window.location = '/rally?eventID=' + this.overallEventID;
    },
  }
});
